/* 
  This maps the index names from algolia to snippet groupes from contentful
*/

export const mappings = {
  tableColumn: 'oneToOneBundle_table_column',
  tableTop: 'oneToOneBundle_table_top'
}
